import { Component, OnDestroy, OnInit, ViewChild, ChangeDetectorRef, ElementRef, Input, Pipe, PipeTransform, Output, EventEmitter, ViewEncapsulation, AfterViewInit, Directive, HostListener  } from '@angular/core';
import { FormBuilder, Validators, ControlContainer, FormGroupDirective, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common'
import { Subject, Observable } from 'rxjs';
import { CustomerService } from '../../services/customer.service';
import { OrdersService } from '../../services/orders.service';
import { GlobalSearchService } from '../../services/globalsearchservice.service';
import { PurchasingService } from '../../services/purchasing.service';
import { PaymentsService } from '../../services/payments.service';
import { OmsService } from '../../services/oms.service';
import { trigger, state, style, transition, animate, animation } from '@angular/animations';

@Component({
	selector: 'app-counter-pos-invoice',
	templateUrl: './counter-pos-invoice.component.html',
	styleUrls: ['./counter-pos-invoice.component.scss'],
	animations: [
		trigger('navIn', [
			transition(':enter', animation([style({ transform: 'translate(200px,0)', }),
				animate('0.10s cubic-bezier(0.59, 0.32, 0.38, 0.33)',
					style({ transform: 'translate(0)', })
				),
			])),
			transition(':leave', animation([style({ transform: 'translate(0)' }),
				animate('0.0s cubic-bezier(0.59, 0.32, 0.38, 1.13)',
					style({ transform: 'translate(-200px,0)', })
				),
			])),
		]),
	],
})
export class CounterPosInvoiceComponent {

	CHAT_ROOM = 'OrderBoard';

	order: any = {
		header: [],
		details: [],
		tax_data: {},
	};

	orderno: any = '';
	debtorno: any = '';
	branchcode: any = '';
	reprintlink: any = '';
	dispatchlink: any = '';
	dispatching = false;
	invoicing = true;
	dispatch_details: any = [];
	//container for specifics about taxes.
	taxes: any = [];

	freight_tax_total = 0;
	freight_charge = 0.00;
	payment_total = 0.00
	freight_taxes: any = []
	display_total: any = '';

	payments_added: any = [];

	headercolumns = [
		'stockid',
		'quantity',
		'units'
	];

	totals = {
		subtotal: 0.00,
		freight: 0.00,
		tax: 0.00,
		discount: 0.00,
		total: 0.00,
	};
	taxdatatotal = 0;

	prefered_vendor: any = [];
	payments: any = [];
	color = 'blue'
	sending = false;
	posCardpointeEnabled = true;
	empcode: any = '';

	constructor(private omsService:OmsService, private route: ActivatedRoute, private customerService: CustomerService, private orderService: OrdersService, private location: Location, public router: Router, private globalSearchService: GlobalSearchService, private purchasingService: PurchasingService, private paymentsService: PaymentsService) {
		this.color = this.globalSearchService.getColor();
	}

	showInvoiceResultandReset(event: any) {
		const data = [];
		this.omsService.sendOrderCheckUpdate({ data, roomName: this.CHAT_ROOM }, cb => {
		});
	}

	emitCustomerUpdate(event:any) {

	}

	ngOnInit(): void {

		this.globalSearchService.configsubscription.subscribe((cfg: any) => {
			this.posCardpointeEnabled = cfg?.features?.posCardpointe !== false;
		});

		this.route.params.subscribe(params => {
			this.orderno = params.id
			this.orderService.getOrder(this.orderno).subscribe((details) => {
				this.order = details
				this.freight_charge = parseFloat(this.order.header.freightcost)
				this.debtorno = this.order.header.debtorno
				this.branchcode = this.order.header.branchcode
				this.orderno = this.order.header.orderno

				const data = {
					orderno: this.order.header.orderno,
					debtorno: this.order.header.debtorno,
					branchcode: this.order.header.branchcode,
				}

				this.globalSearchService.empCode.subscribe(r => {
					if (r) {
						this.empcode = r;
					}
				});


				this.paymentsService.getOrderPayments(data).subscribe((results: any) => {
					this.payments = results;
					this.updateTotals();
				})
			})
		})
	}

	getBalance() {
		const value = this.payment_total - this.totals.total;
		//if(value < 0) {
		//	value = 0.00
		//}
		return value;
	}

	createInvoice() {
		if (this.order) {
			const data = {
				order: this.order,
				totals: this.totals,
				payments: this.payments_added,
				taxes: this.taxes,
				empcode: this.empcode,
				skip_card_for_invoice: !this.posCardpointeEnabled,
			}
			this.sending = true;
			this.orderService.createInvoice(data).subscribe((results: any) => {
				this.sending = false;
				if (results.success) {
					this.globalSearchService.empCode.next(false);
					this.router.navigate(['/pos/success/' + results.id]);
					
				} else {
					alert('Error');
				}
			});
		}
	}

	updateDispatchQty(event: any, item: any) {

		if(event.target.value < 0) {
			event.target.value = 0;
		}

		if (parseFloat(item.ordered) >= parseFloat(event.target.value)) {
			item.dispatch = this.santizeNumberValue(event.target.value);
		} else {

			event.target.value = parseFloat(item.ordered);
			item.dispatch = parseFloat(item.ordered)
		}

		this.updateTotals()
	}

	setQty(event: any, item: any) {
		if (parseFloat(item.ordered) < parseFloat(event.target.value)) {
			item.dispatch = this.santizeNumberValue(event.target.value);
		} else {
			item.dispatch = item.ordered;
		}

		this.updateTotals()
	}

	updatePayments(event: any) {
		this.payments_added = event;
		this.payment_total = this.payments_added.reduce(function(accumulator, item) {
			return parseFloat(accumulator) + parseFloat(item.amount);
		}, 0);
	}

	setFreightCharge(event: any) {
		this.order.header.freightcost = this.santizeNumberValue(event.target.value);
		this.freight_charge = this.order.header.freightcost;
		this.updateTotals();
	}

	setFreightTax(event: any, tax: any) {
		tax.taxrate = this.santizeNumberValue(event.target.value);
		this.updateTotals();
	}

	setTax(event: any, item: any, taxinndex: any) {
		item.taxes[taxinndex].taxrate = this.santizeNumberValue(event.target.value);
		this.updateTotals();
	}

	getFreightTax() {
		const total = 0
		this.freight_tax_total = 0;
		const freight = this.freight_charge
		let freighttax = 0;
		if (this.order) {
			const taxauths = [];
			this.freight_taxes = this.order.freight_tax;

			//by auth
			this.order.freight_tax.forEach((tax, index) => {
				taxauths.push({ taxauthid: tax.taxauthid, value: ((tax.taxrate / 100)* freight) })
			});

			this.freight_taxes = taxauths;
			//total freight tax
			freighttax = this.order.freight_tax.reduce(function(accumulator, tax) {
				return parseFloat(accumulator) + ((tax.taxrate /100) * freight);
			}, 0);
		}

		this.freight_tax_total = freighttax;
		return freighttax;
	}

	updateTotals() {

		//todo clean this up. requires two containers..
		//parse items subtotals / taxes first.
		this.totals = {
			subtotal: 0.00,
			freight: 0.00,
			tax: 0.00,
			discount: 0.00,
			// adjustment: 0.00,
			total: 0.00,
		};
		this.totals.total = 0;
		let totaltax = 0;
		//zero out tax containers
		const parent = this;

		this.order.tax_data.authorities.forEach((item, index) => {
			this.order.tax_data.authorities[index].total = 0;
		});

		const freighttax = this.getFreightTax()
		//add freight tax to tax total container

		this.freight_taxes.forEach((fghtax) => {
			this.order.tax_data.authorities.forEach((tax, index) => {
				if (tax.taxauthid == fghtax.taxauthid) {
					const value = parseFloat(Number.parseFloat(fghtax.value).toFixed(2));
					if (value) {
						this.order.tax_data.authorities[index].total += parseFloat(Number.parseFloat(fghtax.value).toFixed(2));
					}
				}
			})
		})

		if (this.order) {
			if(this.order.details && this.order.details.length) {
				this.order.details.forEach((item, index) => {
					//subtotals
					// Round the LINE, not the unit. The server posts the discount as
					// round(unitprice * discountpercent * dispatch, 2) — rounding the discounted
					// unit price first drifts every unit and lands the invoice out of balance.
					const linegross = parent.phpRound(item.unitprice * item.dispatch);
					// toFixed(6) first: PHP's round() compensates for float artifacts
					// (22.75 * 0.1 * 3 = 6.824999999999999) and financial() does not.
					const linediscount = parent.phpRound(item.unitprice * item.discountpercent * item.dispatch);
					const subtotal = parent.financial(linegross - linediscount);

					this.order.details[index].linesubtotal = subtotal;

					const parentindex = index;
					//this.order.details[index].taxtotal = 0;
					//item tax breakdown
					if (this.order.tax_data.authorities.length > 0) {
						item.taxes.forEach((tax, subindex) => {

							const thistax = this.order.tax_data.authorities.filter(all => all.taxauthid == tax.taxauthid)[0];
							if (thistax) {
								//!! LET PHP HANDLE THE ROUNDING
								const tindex = this.order.tax_data.authorities.indexOf(thistax);
								const authtax =  parent.financial(((tax.taxrate / 100) * subtotal));

								if (authtax) {
									if (this.order.tax_data.authorities[tindex]) {
										this.order.tax_data.authorities[tindex].total += authtax;
										this.order.details[parentindex].taxes[subindex].total = authtax;
									}
								} else {
									if (this.order.tax_data.authorities[tindex]) {
										this.order.tax_data.authorities[tindex].total += 0.00;
										this.order.details[parentindex].taxes[subindex].total = 0.00;
									}
								}
							}
						});
					}
					//after
					const total_linetax = item.taxes.reduce(function(accumulator, line) {
						return accumulator + parent.financial(((line.taxrate / 100) * subtotal));
					}, 0);

					this.order.details[index].taxtotal = (total_linetax);
					this.order.details[index].linetotal = (total_linetax + subtotal);

					totaltax += total_linetax;
				});
			}

			this.totals.subtotal = this.order.details.reduce(function(accumulator, line) {
				//this financial not avail in reduce
				const linegross = parent.phpRound(line.unitprice * line.dispatch);
				const linediscount = parent.phpRound(line.unitprice * line.discountpercent * line.dispatch);
				const subtotal = parent.financial(linegross - linediscount);

				return accumulator + subtotal;
			}, 0);

			this.taxdatatotal = this.order.tax_data.authorities.reduce(function(accumulator, line) {
				return accumulator + (line.total);
			}, 0);


			//total tax includes freight tax
			this.totals.tax = this.financial(totaltax) + this.financial(freighttax);
			this.totals.freight = this.freight_charge;
			//this.totals.adjustment = this.financial(this.adjustment);
			this.totals.total = this.totals.subtotal + this.totals.freight + this.totals.tax + this.totals.discount;
		}
	}

	/** PHP's round(), reproduced. PHP collapses float noise before rounding, so
	 *  round(27.90 * 0.15, 2) — a raw 4.18499999999999961 — returns 4.19, while
	 *  financial() returns 4.18. The server posts the discount with PHP round(),
	 *  the client bills debtortrans.ovamount, so a formula that is one cent apart
	 *  on a single line puts the whole journal out of balance. Scale first, then
	 *  cut the noise at 15 significant digits, then round half-up like PHP.
	 *  See migrations/km_gl_discount_rounding_fix_* and the 2026-08-21 batch. */
	phpRound(value: number, places: number = 2): number {
		const factor = Math.pow(10, places);
		const scaled = Number((Number(value) * factor).toPrecision(15));
		return Math.round(scaled) / factor;
	}

	financial(num: number): number {
		const rounded = Math.round((num + Number.EPSILON) * 100) / 100; // Rounding to 2 decimal places again
		return parseFloat(rounded.toFixed(2));
	}

	santizeNumberValue(input: any) {
		return (Number.isNaN(parseFloat(input)) || input == '') ? 0 : parseFloat(input);
	}

	back(): void {
		this.location.back()
	}

	addPoItems(supplier: any) {

		const item = [{
			stockid: '',
			description: '',
			line_notes: '',
			qty: '',
			price: '',
		}];

		this.purchasingService.addToOrder(item, supplier).subscribe((result) => {

		})
	}

	ngAfterViewInit(): void {

	}

}
